import React from 'react';
import { cn } from 'src/lib/utils';
import { cva } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';

const spinnerVariants = cva('flex-col items-center justify-center', {
  variants: {
    show: {
      true: 'flex',
      false: 'hidden',
    },
  },
  defaultVariants: {
    show: true,
  },
});

const iconVariants = cva('animate-spin text-primary', {
  variants: {
    size: {
      small: 'h-4 w-4',
      medium: 'h-6 w-6',
      large: 'h-10 w-10',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});

const Spinner = React.forwardRef(function Spinner({ size, show = true, children, className, ...props }, ref) {
  return (
    <span ref={ref} className={spinnerVariants({ show })} {...props}>
      <Loader2 className={cn(iconVariants({ size }), className)} strokeWidth={1.5} />
      {children}
    </span>
  );
});

export { Spinner };
